import {Component, inject} from "@angular/core";
import {RouterOutlet} from "@angular/router";
import {DataImmuablesDomainService} from "./core/domain/data-immuables.domain";
import {UserDomainService} from "./core/domain/user.domain";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [ RouterOutlet]
})
export class AppComponent {
    title = 'Manager hiérarchique'

    private dataImmuablesDomain = inject(DataImmuablesDomainService)
    private userDomainService = inject(UserDomainService)

    constructor() {
        this.dataImmuablesDomain.setDeviceInformations()
        this.userDomainService.initUser().subscribe()
    }

}
